import axios from 'axios'
import router from '@/router'
import store from '@/store'

const apiPath = 'https://api.liveabc.com/v1'

const Api = axios.create({
  baseURL: apiPath,
  timeout: 1000 * 60 * 60,
  headers: {
    'access-control-allow-origin': '*'
    // 'Content-Type': 'application/json',
  },
})

// Request 拦截器
Api.interceptors.request.use(request => {
  const token = localStorage.getItem('qrCodeToken')

  if (!request.headers) {
    request.headers = {}
  }

  if (token) {
    request.headers['Authorization'] = `Bearer ${token}`
  }

  axios.defaults.withCredentials = false

  return request
})

// Response 拦截器
Api.interceptors.response.use(
  (response) => {
    const { error } = response.data

    if (error) {
      switch (error) {
        case 'TOKEN_EXPIRED':
          store.dispatch('refreshToken')
          break
        case 'TOKEN_INVALID':
          store.dispatch('logout')
          router.push({ name: 'login' })
          break
        default:
          break
      }
    }

    store.dispatch('isLoading', false)
    return response
  },
  (error) => {
    if (error.response) {
      const { response } = error

      if (response) {
        const { status } = response

        switch (status) {
          case 401:
            alert('請重新登入')
            store.dispatch('logout')
            // router.push({ name: 'login' })
            break
          case 429:
            alert('系統忙碌中，請稍後再試。')
            break
          case 500:
            console.log(response)
            // store.commit('setErrorMessage', response)
            break
          default:
            console.log(response)
            // store.commit('setErrorMessage', response)
            break
        }
      } else {
        store.commit('setErrorMessage', error.message)
      }
    }

    return Promise.reject(error)
  }
)

export default Api
